import { useTranslation } from 'next-i18next';
import { overlay } from 'overlay-kit';
import { type MapTemplate, type MapTemplateType } from '@/types/MapTemplate';
import { DialogHeader, ResponsiveDialog } from '@/ui_v3';
import { MapSelectionView } from './components';

// Re-export public APIs
export { MapSelectionView } from './components';
export { useShowMapTemplateModal } from './hooks';

// ============================================================================
// Modal wrapper (기존 코드 호환성을 위한 export)
// ============================================================================

interface MapTemplateSelectModalProps {
  mapTemplates: MapTemplate[];
  selectedMapTemplateId?: string;
  userCountryCode?: string;
  isChange?: boolean;
  focusFirstFreeMap?: boolean;
  onSubmit: (selectedMapTemplateId: string, mapTemplateType: MapTemplateType) => void;
  onClose?: VoidFunction;
}
const MapTemplateSelectModal = ({
  mapTemplates,
  selectedMapTemplateId,
  userCountryCode,
  isChange,
  focusFirstFreeMap,
  onSubmit,
  onClose
}: MapTemplateSelectModalProps) => {
  const {
    t
  } = useTranslation(['build']);
  return <ResponsiveDialog size="2xl" className="h-[90%] max-h-[800px] tablet-sm:gap-xs [&[vaul-drawer][vaul-drawer-direction=bottom]::after]:hidden" onClose={onClose} data-sentry-element="ResponsiveDialog" data-sentry-component="MapTemplateSelectModal" data-sentry-source-file="index.tsx">
      <DialogHeader title={t('build:mapTemplate.selectQuizMap')} hasCloseButton={true} onClose={onClose} data-sentry-element="DialogHeader" data-sentry-source-file="index.tsx" />
      <MapSelectionView mapTemplates={mapTemplates} selectedMapTemplateId={selectedMapTemplateId} userCountryCode={userCountryCode} isChange={isChange} focusFirstFreeMap={focusFirstFreeMap} onComplete={onSubmit} data-sentry-element="MapSelectionView" data-sentry-source-file="index.tsx" />
    </ResponsiveDialog>;
};
export const mapTemplateSelectModal = {
  openAsync({
    onClose,
    onSubmit,
    ...props
  }: MapTemplateSelectModalProps) {
    return overlay.openAsync(({
      unmount
    }) => <MapTemplateSelectModal {...props} onSubmit={(selectedMapTemplateId, mapTemplateType) => {
      onSubmit(selectedMapTemplateId, mapTemplateType);
      unmount();
    }} onClose={() => {
      onClose?.();
      unmount();
    }} />);
  }
};